const team_data = [
	{
		id: '0',
		image: '/images/team/team_1.png',
		title: 'CEO & Co-founder',
		name: 'Miguel Ángeles',
		linkedin: 'https://pe.linkedin.com/in/miguel-%C3%A1ngeles-d%C3%A1vila-3026a4195'
	},
	{
		id: '1',
		image: '/images/team/team_2.png',
		title: 'CTO & Co-founder',
		name: 'Rodrigo Vega',
		linkedin: 'https://pe.linkedin.com/in/rodrigo-vega-centeno-ponce-de-le%C3%B3n-ab96a4195'
	},
	{
		id: '2',
		image: '/images/team/team_3.png',
		title: 'Co-founder',
		name: 'Erick Carranza',
		linkedin: 'https://pe.linkedin.com/in/erick-carranza-5568b2140'
	},
	{
		id: '3',
		image: '/images/team/team_4.png',
		title: 'CRO & Co-founder',
		name: 'Kevin Acuña',
		linkedin: 'https://pe.linkedin.com/in/kevin-jos%C3%A9-acu%C3%B1a-condori-843158194'
	},
	{
		id: '4',
		image: '/images/team/team_5.png',
		title: 'COO & Co-founder',
		name: 'Jean Porras',
		linkedin: 'https://pe.linkedin.com/in/jeanporras12'
	},
	{
		id: '5',
		image: '/images/team/team_6.png',
		title: 'CDO',
		name: 'Lizbeth Núñez',
		linkedin: 'https://pe.linkedin.com/in/lizbethdiaznunez'
	},
	{
		id: '6',
		image: '/images/team/team_7.png',
		title: 'Ingeniero de Proyectos',
		name: 'Luis Pun',
		linkedin: 'https://www.linkedin.com/in/luis-alonso-pun-mej%C3%ADa-8935a5180/'
	},
	{
		id: '7',
		image: '/images/team/team_8.png',
		title: 'Ingeniera de Proyectos Jr.',
		name: 'María Alejandra',
		linkedin: 'https://www.linkedin.com/in/alejandraguzm%C3%A1n/'
	},
	{
		id: '8',
		image: '/images/team/team_9.png',
		title: 'Ingeniero de Proyectos Jr.',
		name: 'Rodrigo Carranza',
		linkedin: 'https://www.linkedin.com/company/cirsys/'
	},
];

export { team_data };
